'use strict';

var novicell = novicell || {};

novicell.multiModal = novicell.multiModal || new function () {

    this.init = function () {
        const modalItems = document.querySelectorAll('.js-multi-modal-item');

        if (!modalItems || window.innerWidth < 1024) {
            return;
        }

        for (let i = 0; i < modalItems.length; i++) {
            const item = modalItems[i];

            item.addEventListener('mouseover', e => {
                const redLines = document.querySelector('#red-lines');
                const blueLines = document.querySelector('#blue-lines');
                const fredericiaDot = document.querySelector('#fredericia-dot');
                const taulovDot = document.querySelector('#taulov-dot');
                let target = null;

                switch (i) {
                    case 1:
                        {
                            target = fredericiaDot;
                            break;
                        }

                    case 2:
                        {
                            target = taulovDot;
                            break;
                        }
                    case 3:
                        {
                            target = blueLines;
                            break;
                        }

                    default:
                        {
                            target = redLines;
                            break;
                        }
                }

                target.classList.add('multi-modal--active');
            }, false);

            item.addEventListener('mouseout', e => {
                let target = document.querySelector('.multi-modal--active');

                if (!target) {
                    return;
                }

                target.classList.remove('multi-modal--active');
            }, false);
        }
    };

};
